const initialState = () => ({
  course: {
    details: undefined,
    selectedUuid: ""
  },
  bookmark: {
    courses: [],
    loading: false
  },
  group: {
    courses: undefined,
    cefrjLevelCounts: {},
    categories: {}
  },
  organization: {
    courses: [],
    cefrjLevelCounts: {},
    categories: {}
  },
  recommended: {
    courses: [],
    loading: false
  }
});

const contentState = initialState();

export { contentState };
